<template>
	<v-dialog
			:value="true"
			:width="dialogWidth"
			:z-index="zIndex"
			:dark="isDarkTheme"
			:fullscreen="isFullScreen"
			persistent
			scrollable
			transition="dialog-transition"
			content-class="modal-window__content"
			overlay-class="modal-window__overlay"
	>
		<div class="modal-window"
		     :class="[{ isFullScreen: isFullScreen }, {isFooterFlexEnd: isFooterFlexEnd}]">

			<div class="modal-window__top">
				<div class="modal-window__title">
					<div v-html="title"></div>
					<div class="subTitle"><slot name="subTitle"></slot></div>
				</div>

				<div class="topButtons">
					<div class="topButtonsWrap">
						<slot name="topButtons"></slot>
					</div>
					<v-btn
							icon
							color="green"
							class="deleteBtn"
							type="button"
							@click="onClose('close')"
					>
						<svg-sprite width="20" height="20" icon-id="close" />
					</v-btn>
				</div>
			</div>

			<div class="modal-window__body">
				<slot></slot>
			</div>

			<div class="modal-window__footer">
				<div v-if="$slots.subTitleFooter && $slots.subTitleFooter.length" class="wrap">
					<slot name="subTitleFooter"></slot>
				</div>
				<div class="buttonGroupsWrap">
					<button-groups
							v-if="isShowButtonGroups"
							@updateBtnClose="onClose('cancel')"
							:cancel-text="cancelText"
							:preloader="preloader"
							@updateSave="onSave"
							:apply-text="applyText"
							:is-cancel-hide="isCancelHide"
							:is-btn-safe="isBtnSafe"
							:is-save="isSave"
					/>
				</div>
			</div>

		</div>
	</v-dialog>
</template>

<script>
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";

export default {
	name: "DialogSlot",
	components: { ButtonGroups },
	inject: [ 'themeIsDark' ],
	computed: {
		isDarkTheme() {
			// если provide вернул функцию (наш случай) — вызываем её
			if (typeof this.themeIsDark === 'function') {
				return !!this.themeIsDark();
			}
			// если когда-то будет просто boolean — тоже приведём к Boolean
			return !!this.themeIsDark;
		},
		dialogWidth() {
			return this.isFullScreen ? '100%' : this.width;
		}
	},
	props: {
		preloader: Boolean,
		isCancelHide: Boolean,
		title: String,
		isBtnSafe: Boolean,
		isFullScreen: Boolean,
		isFooterFlexEnd: Boolean,
		cancelText: {
			type: String,
			default: () => 'Cancel'
		},
		applyText: {
			type: String,
			default: () => 'Save'
		},
		zIndex: {
			type: String,
			default: () => '1000'
		},
		width: {
			type: String,
			default: () => '500px'
		},
		isShowButtonGroups: {
			type: Boolean,
			default: () => true
		},
		isFooter: {
			type: Boolean,
			default: () => true
		},
		isSave: {
			type: Boolean,
			default: () => true
		},
	},
	methods: {
		onClose(type) {
			this.$emit('updateClose', type);
		},
		onSave() {
			this.$emit('updateSave');
		}
	}
};
</script>

<style scoped lang="scss">
.modal-window {
	display: flex;
	flex-direction: column;
	background-color: var(--card-bg);
	color: var(--card-color);
	border-radius: 8px;
	overflow: hidden;

	&__top {
		padding: 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	&__title {
		font-size: 18px;
		display: flex;
		align-items: center;
		gap: 10px;
		.subTitle {

		}
	}

	.topButtons {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 16px;
		.topButtonsWrap {
			display: flex;
			align-items: center;
			justify-content: flex-end;
			gap: 16px;
		}
	}

	&__body {
		background:  var(--base-bg);
		//max-height: 480px;
		overflow-y: auto;
		padding: 20px;
	}
	&__footer {
		padding: 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
		.wrap {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 10px;

			/* если wrap есть — он встанет слева и вытолкнет кнопки вправо */
			margin-right: auto;
			min-width: 0; /* чтобы контент не ломал флекс */
		}

		.buttonGroupsWrap {
			margin-left: auto; /* гарантированно держим справа */
		}
	}
	&.isFullScreen {
		.modal-window__top,
		.modal-window__footer {
			box-shadow: var(--card-shadow);
			position: relative;
			z-index: 10;
		}
	}
	&.isFooterFlexEnd {
		.modal-window__footer {
			align-items: flex-end;
		}
	}
}

.modal-window__overlay {
	background-color: rgba(0, 0, 0, 0.4) !important;
}
</style>

